// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { MpcreditoMessage } from './mpcredito-message';
import { MpcreditoInstructions } from './mpcredito-instructions';

export function DisplayMpcreditoInstructions(): Node {
  return (
    <Root>
      <MpcreditoMessage  />
      <MpcreditoInstructions />
    </Root>
  );
}

const Root = styled.div`
  margin: 0;
`;
